import { Navigate } from "react-router-dom";
import { usePortalAuth } from "@/lib/PortalAuthContext";

export default function PortalProtectedRoute({ children }) {
  const { user } = usePortalAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-[#D4AF37] text-sm tracking-widest">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/portal/login" replace />;
  return children;
}
